//#region src/flag/index.ts
var flags = {
	ad: async () => import("./ad.js"),
	ae: async () => import("./ae.js"),
	af: async () => import("./af.js"),
	ag: async () => import("./ag.js"),
	ai: async () => import("./ai.js"),
	al: async () => import("./al.js"),
	am: async () => import("./am.js"),
	ao: async () => import("./ao.js"),
	ar: async () => import("./ar.js"),
	as: async () => import("./as.js"),
	at: async () => import("./at.js"),
	au: async () => import("./au.js"),
	aw: async () => import("./aw.js"),
	ax: async () => import("./ax.js"),
	az: async () => import("./az.js"),
	ba: async () => import("./ba.js"),
	bb: async () => import("./bb.js"),
	bd: async () => import("./bd.js"),
	be: async () => import("./be.js"),
	bf: async () => import("./bf.js"),
	bg: async () => import("./bg.js"),
	bh: async () => import("./bh.js"),
	bi: async () => import("./bi.js"),
	bj: async () => import("./bj.js"),
	bl: async () => import("./bl.js"),
	bm: async () => import("./bm.js"),
	bn: async () => import("./bn.js"),
	bo: async () => import("./bo.js"),
	"bq-1": async () => import("./bq-1.js"),
	"bq-2": async () => import("./bq-2.js"),
	bq: async () => import("./bq.js"),
	br: async () => import("./br.js"),
	bs: async () => import("./bs.js"),
	bt: async () => import("./bt.js"),
	bw: async () => import("./bw.js"),
	by: async () => import("./by.js"),
	bz: async () => import("./bz.js"),
	ca: async () => import("./ca.js"),
	cc: async () => import("./cc.js"),
	cd: async () => import("./cd.js"),
	"cd-1": async () => import("./cd-1.js"),
	cf: async () => import("./cf.js"),
	cg: async () => import("./cg.js"),
	ch: async () => import("./ch.js"),
	ck: async () => import("./ck.js"),
	cl: async () => import("./cl.js"),
	cm: async () => import("./cm.js"),
	cn: async () => import("./cn.js"),
	co: async () => import("./co.js"),
	cr: async () => import("./cr.js"),
	cu: async () => import("./cu.js"),
	cv: async () => import("./cv.js"),
	cw: async () => import("./cw.js"),
	cx: async () => import("./cx.js"),
	cy: async () => import("./cy.js"),
	cz: async () => import("./cz.js"),
	de: async () => import("./de.js"),
	dj: async () => import("./dj.js"),
	dk: async () => import("./dk.js"),
	dm: async () => import("./dm.js"),
	do: async () => import("./do.js"),
	ds: async () => import("./ds.js"),
	dz: async () => import("./dz.js"),
	ec: async () => import("./ec.js"),
	ee: async () => import("./ee.js"),
	eg: async () => import("./eg.js"),
	eh: async () => import("./eh.js"),
	er: async () => import("./er.js"),
	es: async () => import("./es.js"),
	eu: async () => import("./eu.js"),
	et: async () => import("./et.js"),
	fi: async () => import("./fi.js"),
	fj: async () => import("./fj.js"),
	fk: async () => import("./fk.js"),
	fm: async () => import("./fm.js"),
	fo: async () => import("./fo.js"),
	fr: async () => import("./fr.js"),
	ga: async () => import("./ga.js"),
	gb: async () => import("./gb.js"),
	"gb-2": async () => import("./gb-2.js"),
	gd: async () => import("./gd.js"),
	ge: async () => import("./ge.js"),
	gf: async () => import("./gf.js"),
	gg: async () => import("./gg.js"),
	gh: async () => import("./gh.js"),
	gi: async () => import("./gi.js"),
	gl: async () => import("./gl.js"),
	gm: async () => import("./gm.js"),
	gn: async () => import("./gn.js"),
	gp: async () => import("./gp.js"),
	gq: async () => import("./gq.js"),
	gr: async () => import("./gr.js"),
	gt: async () => import("./gt.js"),
	gu: async () => import("./gu.js"),
	gw: async () => import("./gw.js"),
	gy: async () => import("./gy.js"),
	hk: async () => import("./hk.js"),
	hn: async () => import("./hn.js"),
	hr: async () => import("./hr.js"),
	ht: async () => import("./ht.js"),
	hu: async () => import("./hu.js"),
	id: async () => import("./id.js"),
	ie: async () => import("./ie.js"),
	il: async () => import("./il.js"),
	im: async () => import("./im.js"),
	in: async () => import("./in.js"),
	io: async () => import("./io.js"),
	iq: async () => import("./iq.js"),
	ir: async () => import("./ir.js"),
	is: async () => import("./is.js"),
	it: async () => import("./it.js"),
	je: async () => import("./je.js"),
	jm: async () => import("./jm.js"),
	jo: async () => import("./jo.js"),
	jp: async () => import("./jp.js"),
	ke: async () => import("./ke.js"),
	kg: async () => import("./kg.js"),
	kh: async () => import("./kh.js"),
	ki: async () => import("./ki.js"),
	km: async () => import("./km.js"),
	kn: async () => import("./kn.js"),
	kp: async () => import("./kp.js"),
	kr: async () => import("./kr.js"),
	kw: async () => import("./kw.js"),
	ky: async () => import("./ky.js"),
	kz: async () => import("./kz.js"),
	la: async () => import("./la.js"),
	lb: async () => import("./lb.js"),
	lc: async () => import("./lc.js"),
	li: async () => import("./li.js"),
	lk: async () => import("./lk.js"),
	lr: async () => import("./lr.js"),
	ls: async () => import("./ls.js"),
	lt: async () => import("./lt.js"),
	lu: async () => import("./lu.js"),
	lv: async () => import("./lv.js"),
	ly: async () => import("./ly.js"),
	ma: async () => import("./ma.js"),
	mc: async () => import("./mc.js"),
	md: async () => import("./md.js"),
	me: async () => import("./me.js"),
	mg: async () => import("./mg.js"),
	mh: async () => import("./mh.js"),
	mk: async () => import("./mk.js"),
	ml: async () => import("./ml.js"),
	mm: async () => import("./mm.js"),
	mn: async () => import("./mn.js"),
	mo: async () => import("./mo.js"),
	mp: async () => import("./mp.js"),
	mq: async () => import("./mq.js"),
	mr: async () => import("./mr.js"),
	ms: async () => import("./ms.js"),
	mt: async () => import("./mt.js"),
	mu: async () => import("./mu.js"),
	mv: async () => import("./mv.js"),
	mw: async () => import("./mw.js"),
	mx: async () => import("./mx.js"),
	my: async () => import("./my.js"),
	mz: async () => import("./mz.js"),
	na: async () => import("./na.js"),
	nc: async () => import("./nc.js"),
	ne: async () => import("./ne.js"),
	nf: async () => import("./nf.js"),
	ng: async () => import("./ng.js"),
	ni: async () => import("./ni.js"),
	nl: async () => import("./nl.js"),
	no: async () => import("./no.js"),
	np: async () => import("./np.js"),
	nr: async () => import("./nr.js"),
	nu: async () => import("./nu.js"),
	nz: async () => import("./nz.js"),
	om: async () => import("./om.js"),
	pa: async () => import("./pa.js"),
	pe: async () => import("./pe.js"),
	pf: async () => import("./pf.js"),
	pg: async () => import("./pg.js"),
	ph: async () => import("./ph.js"),
	pk: async () => import("./pk.js"),
	pl: async () => import("./pl.js"),
	pn: async () => import("./pn.js"),
	pr: async () => import("./pr.js"),
	ps: async () => import("./ps.js"),
	pt: async () => import("./pt.js"),
	pw: async () => import("./pw.js"),
	py: async () => import("./py.js"),
	qa: async () => import("./qa.js"),
	re: async () => import("./re.js"),
	ro: async () => import("./ro.js"),
	rs: async () => import("./rs.js"),
	ru: async () => import("./ru.js"),
	rw: async () => import("./rw.js"),
	sa: async () => import("./sa.js"),
	sb: async () => import("./sb.js"),
	sc: async () => import("./sc.js"),
	sd: async () => import("./sd.js"),
	se: async () => import("./se.js"),
	sg: async () => import("./sg.js"),
	si: async () => import("./si.js"),
	sk: async () => import("./sk.js"),
	sl: async () => import("./sl.js"),
	sm: async () => import("./sm.js"),
	sn: async () => import("./sn.js"),
	so: async () => import("./so.js"),
	sr: async () => import("./sr.js"),
	ss: async () => import("./ss.js"),
	st: async () => import("./st.js"),
	sv: async () => import("./sv.js"),
	sx: async () => import("./sx.js"),
	sy: async () => import("./sy.js"),
	sz: async () => import("./sz.js"),
	tc: async () => import("./tc.js"),
	td: async () => import("./td.js"),
	tg: async () => import("./tg.js"),
	th: async () => import("./th.js"),
	tj: async () => import("./tj.js"),
	tk: async () => import("./tk.js"),
	tl: async () => import("./tl.js"),
	tm: async () => import("./tm.js"),
	tn: async () => import("./tn.js"),
	to: async () => import("./to.js"),
	tr: async () => import("./tr.js"),
	tt: async () => import("./tt.js"),
	tv: async () => import("./tv.js"),
	tw: async () => import("./tw.js"),
	tz: async () => import("./tz.js"),
	ua: async () => import("./ua.js"),
	ug: async () => import("./ug.js"),
	us: async () => import("./us.js"),
	uy: async () => import("./uy.js"),
	uz: async () => import("./uz.js"),
	va: async () => import("./va.js"),
	vc: async () => import("./vc.js"),
	ve: async () => import("./ve.js"),
	vg: async () => import("./vg.js"),
	vi: async () => import("./vi.js"),
	vn: async () => import("./vn.js"),
	vu: async () => import("./vu.js"),
	ws: async () => import("./ws.js"),
	xk: async () => import("./xk.js"),
	ye: async () => import("./ye.js"),
	za: async () => import("./za.js"),
	zm: async () => import("./zm.js"),
	zw: async () => import("./zw.js")
};
//#endregion
export { flags };
